<template>
  <component
    :is="tag"
    class="icon-button"
    :class="classes"
    :href="href"
    @click="(event) => $emit('click', event)"
  >
    <i :class="'icon icon-' + icon" />
    <slot />
  </component>
</template>

<script>
import ButtonComponent from "@/components/Button.vue";
export default {
  name: "IconButton",
  extends: ButtonComponent,
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  emits: ["click"],
  computed: {
    classes() {
      return {
        "icon-button--has-text": Boolean(this.$slots.default),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-button {
  background: none;
  outline: none;
  border: none;
  padding: 15px;
  display: inline-block;
  text-decoration: none;

  &--has-text {
    .icon {
      margin-right: 10px;
    }
  }
}
</style>
